module.exports = __webpack_public_path__ + "af.svg?071b4bb7a3dd6b5b950dad50af641d6b";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/af.svg
// module id = 1178
// module chunks = 27